import { merge } from 'lodash';
import view from './view.json';
import { replace } from './replace';

export const german = merge(view, replace);
